<template>
	<div>
		<div class="background--text text--lighten-5 subheading">
			Workflow
		</div>
		<v-autocomplete
			:loading="loading"
			class="mt-0 mb-1 py-0 grv-input"
			ref="jd_selector"
			clearable
			return-object
			autofocus
			hide-details
			item-text="label"
			:menu-props="{contentClass: 'grv-menu'}"
			open-on-clear
			solo
			:items="jds || []"
			persistent-hint
			:value="jd_selected"
			@change="$emit('change', $event)">
			<template slot="selection" slot-scope="data">
				<v-chip
					class="mr-2 pa-0"
					color="background"
					small
					label>
					#{{ data.item.id }}
				</v-chip>
				{{ data.item.label }}
				<v-chip
					v-if="data.item.archived > 0"
					class="ml-2 pa-0"
					color="warning black--text"
					small
					label>
					Archivé
				</v-chip>
			</template>
			<template slot="item" slot-scope="data">
				<v-list-tile-avatar>
					<v-chip label color="background" class="mr-2">
						{{ data.item.id }}
					</v-chip>
				</v-list-tile-avatar>
				<v-list-tile-content>
					<v-list-tile-title>
						{{ data.item.label }}
					</v-list-tile-title>
					<v-list-tile-sub-title class="caption">
						{{ data.item.description || '-' }}
					</v-list-tile-sub-title>
				</v-list-tile-content>
				<v-list-tile-action style="display: contents">
					<span style="min-width: 24px">
						<v-icon
							v-if="data.item.archived"
							title="Archivé"
							color="warning">
							archive
						</v-icon>
					</span>
					<span style="min-width: 24px">
						<v-icon
							v-if="data.item.restricted"
							title="Restreint aux administrateurs"
							color="info">
							security
						</v-icon>
					</span>
				</v-list-tile-action>
			</template>
			<template slot="append-outer">
				<v-menu
					v-model="versions_menu"
					content-class="grv-menu"
					:nudge-width="200"
					offset-y
					v-if="versions.length > 0">
					<template v-slot:activator="{ on }">
						<v-btn
							large
							:loading="loading_versions"
							class="text-none color--text font-weight-bold version-btn"
							v-on="on"
							:color="jd_selected_version_is_last ? 'green accent-3' : 'warning'">
							<span v-if="jd_version_selected" class="ml-1">
								v {{ jd_version_selected.version_number }}
							</span>
						</v-btn>
					</template>
					<v-card>
						<v-list class="background darken-1">
							<v-list-tile
								v-for="version in versions"
								:key="version.version_number"
								:class="getVersionColor(version.version_number).text"
								@click.stop="version_num = version.version_number;
														versions_menu = false">
								<v-list-tile-action>
									<v-switch
										:color="getVersionColor(version.version_number).switch"
										v-model="version_num"
										:value="version.version_number">
									</v-switch>
								</v-list-tile-action>
								<v-list-tile-content>
									<v-list-tile-title>
										v {{ version.version_number }}
									</v-list-tile-title>
									<v-list-tile-sub-title style="opacity: .7; color: inherit">
										{{ version.version_description }}
									</v-list-tile-sub-title>
								</v-list-tile-content>
							</v-list-tile>
						</v-list>
					</v-card>
				</v-menu>
				<slot name="jd-append"></slot>
			</template>
		</v-autocomplete>
		<div
			v-for="(desc, i) in jd_selected_hint"
			:key="'desc_' + i"
			class="caption background--text text--lighten-5">
			{{ desc }}
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'jds',
		'jd_type_selected',
		'jd_selected',
		'jd_version_selected',
		'loading',
		'versions'
	],
	data () {
		return {
			loading_versions: false,
			versions_menu: false,
			version_num: null
		}
	},
	watch: {
		jd_version_selected (val) {
			if (val) {
				this.version_num = val.version_number
				return
			}
			this.version_num = null
		},
		version_num (val) {
			if (val) {
				for (const version of this.versions) {
					if (version.version_number === val) {
						this.$emit('version-selected', version)
						return
					}
				}
			}
			this.$emit('version-selected', null)
		}
	},
	computed: {
		jd_selected_hint () {
			let hint = []
			if (this.jd_selected) hint.push(this.jd_selected.description)
			if (this.jd_version_selected) hint.push(this.jd_version_selected.version_description)
			return hint
		},
		jd_selected_version_is_last () {
			if (!this.jd_version_selected) return false
			if (!this.versions[0]) return false
			return this.jd_version_selected.version_number === this.versions[0].version_number
		}
	},
	methods: {
		getVersionColor (version_num) {
			if (this.jd_selected_version_is_last && this.version_num === version_num) {
				return {
					text: 'green--text text--accent-3',
					switch: 'green accent-3'
				}
			}
			if (this.version_num === version_num) {
				return {
					text: 'warning--text',
					switch: 'warning'
				}
			}
			return {
				text: '',
				switch: ''
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.grv-input
.grv-input-dense
	>>>.v-input__append-outer
		width: auto !important
		margin: 0 !important
		button:not(.v-btn--icon)
			min-width: fit-content
			height: 48px
			padding: 0 16px
			display: flex
			margin: 0 0 0 8px
		button.v-btn--icon
			height: 48px
			border: 1px solid
			border-top-left-radius: 0
			border-bottom-left-radius: 0
			border-top-right-radius: 2px
			border-bottom-right-radius: 2px
		button.v-btn--icon:before
			border-top-left-radius: 0
			border-bottom-left-radius: 0
			border-top-right-radius: 2px
			border-bottom-right-radius: 2px
		button.typed-btn
			border-top-right-radius: 0
			border-bottom-right-radius: 0
		button.type-btn:before
		button.freq-btn:before
			opacity: 1
			background-color: rgba(0, 0, 0, 0.15)
			border: 0.5px solid var(--v-background-lighten2)
		button.version-btn
			border: 0.5px solid var(--v-background-darken2) !important
</style>



// WEBPACK FOOTER //
// src/pages/maestro/launcher/launcher_jds_menu.vue